module.exports = {
      id: "bullet-arrow-usage",
      viewBox: "0 0 22 20",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#bullet-arrow",
      toString: function () {
        return this.url;
      }
    }